export default __webpack_public_path__ + "2cf6d0b2de012ff294ce86eecb4263e5.ttf";